import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { DatePipe } from '@angular/common';
import { switchMap } from 'rxjs/operators';
import { Order } from '@models/order';
import { User } from 'src/app/models/user';
import { OrderNotesService, OrderService } from 'src/app/services/order.service';
import { UserService } from 'src/app/services/user.service';
import { OrderNote } from 'src/app/models/order';

@Component({
  selector: 'gob-note-list',
  templateUrl: './note-list.component.html',
  styleUrls: ['./note-list.component.css']
})
export class NoteListComponent implements OnInit {
  @Output() readonly edit: EventEmitter<OrderNote> = new EventEmitter<OrderNote>();
  @Input() order: Order;

  loading: boolean=false;
  currentUser: User | null = null;
  openNote: boolean=false;

  constructor(
    private userServ: UserService,
    private notesSvc: OrderNotesService,
    private orderServ: OrderService

  ) {
    this.currentUser = this.userServ.user;

   }

  ngOnInit(): void {
  }

  getPrivateNotes() {
    return this.order.notes.filter((n: { type: string; state: string; }) => n.type=='private' && n.state=='active');
  }

  /**
   * Remove a private note of an order.
   * @param {any} note - The note to remove.
   * @example
   * this.rmPrivateNote(note)
   */
  rmPrivateNote(note: any){
    if(confirm('Etes vous sûr de vouloir supprimer cette note interne ?')){
      if (this.currentUser.ident != note.utilIdent) return;
      this.loading=true;
      this.notesSvc.rmOrderNote(this.order.ident, note.id).pipe(
        switchMap(() => this.orderServ.getOrder(this.order.ident))
      ).subscribe((order: any) => {
        this.order=order;
        this.loading=false;
      });
    }
  }

/**
 * Emits the note to edit to the parent component.
 * @param {OrderNote} note - The note to edit.
 * @example
 * this.editPrivateNote(note)
 */
  editPrivateNote(note: OrderNote){
    this.edit.emit(note);
  }
}
